import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createVNode as _createVNode, normalizeClass as _normalizeClass, withKeys as _withKeys } from "vue"

const _hoisted_1 = { class: "LoginPage_wrapper" }
const _hoisted_2 = { class: "LoginPage_asideHeader" }
const _hoisted_3 = { class: "LoginPage_container" }
const _hoisted_4 = { class: "LoginPage_header" }
const _hoisted_5 = { class: "LoginPage_headerWrapper" }
const _hoisted_6 = { class: "LoginPage_headerContent" }
const _hoisted_7 = { class: "LoginPage_headerText" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_dev_box = _resolveComponent("dev-box")!
  const _component_language_switch = _resolveComponent("language-switch")!
  const _component_ion_item = _resolveComponent("ion-item")!
  const _component_ion_col = _resolveComponent("ion-col")!
  const _component_ion_row = _resolveComponent("ion-row")!
  const _component_ion_grid = _resolveComponent("ion-grid")!
  const _component_ion_content = _resolveComponent("ion-content")!
  const _component_ion_page = _resolveComponent("ion-page")!

  return (_openBlock(), _createBlock(_component_ion_page, {
    id: "LoginPage",
    class: _normalizeClass(_ctx.componentClass)
  }, {
    default: _withCtx(() => [
      false
        ? (_openBlock(), _createBlock(_component_dev_box, { key: 0 }, {
            default: _withCtx(() => [
              _createTextVNode("store.state: " + _toDisplayString(_ctx.store.state), 1)
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      _createVNode(_component_ion_content, null, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _cache[3] || (_cache[3] = _createElementVNode("div", { class: "LoginPage_ista" }, [
                _createElementVNode("img", {
                  src: "/assets/ista-logo-white.svg",
                  alt: "Ista logo"
                })
              ], -1)),
              _createElementVNode("div", null, [
                _createVNode(_component_language_switch, { class: "LoginPage_LanguageSwitch" })
              ])
            ]),
            _createElementVNode("div", _hoisted_3, [
              _cache[5] || (_cache[5] = _createElementVNode("header", { class: "LoginPage_mainHeader" }, [
                _createElementVNode("img", {
                  src: "/assets/logo/logo-svg-for-export.svg",
                  class: "LoginPage_appLogo"
                }),
                _createElementVNode("h1", { class: "LoginPage_title ui-txt-xl" }, "Park.it")
              ], -1)),
              _createElementVNode("form", {
                onKeyup: _cache[2] || (_cache[2] = _withKeys(
//@ts-ignore
(...args) => (_ctx.handleLoginClick && _ctx.handleLoginClick(...args)), ["enter"])),
                class: "LoginPage_form"
              }, [
                _cache[4] || (_cache[4] = _createElementVNode("div", { class: "LoginPage_stripe" }, [
                  _createElementVNode("div", { class: "LoginPage_stripeDark" })
                ], -1)),
                _createElementVNode("div", _hoisted_4, [
                  _createElementVNode("div", _hoisted_5, [
                    _createElementVNode("div", _hoisted_6, [
                      _createElementVNode("h3", _hoisted_7, _toDisplayString(_ctx.loginHeader), 1)
                    ])
                  ])
                ]),
                _createVNode(_component_ion_grid, { class: "LoginPage_formContent" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_ion_row, { class: "ion-padding-top" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_ion_col, null, {
                          default: _withCtx(() => [
                            (!_ctx.isLoggedIn)
                              ? (_openBlock(), _createBlock(_component_ion_item, {
                                  key: 0,
                                  lines: "none"
                                }, {
                                  default: _withCtx(() => [
                                    _createElementVNode("span", {
                                      class: _normalizeClass({
                        'LoginPage_submitButton': true,
                        'is-disabled': _ctx.isLoggingInOut,
                      }),
                                      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.handleLoginClick && _ctx.handleLoginClick(...args)))
                                    }, _toDisplayString(_ctx.$t('LoginPage.loginButton')), 3)
                                  ]),
                                  _: 1
                                }))
                              : _createCommentVNode("", true),
                            (_ctx.isLoggedIn)
                              ? (_openBlock(), _createBlock(_component_ion_item, {
                                  key: 1,
                                  lines: "none"
                                }, {
                                  default: _withCtx(() => [
                                    _createElementVNode("span", {
                                      onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.handleLogoutClick && _ctx.handleLogoutClick(...args))),
                                      class: _normalizeClass({
                        'LoginPage_submitButton': true,
                        'is-disabled': _ctx.isLoggingInOut,
                      })
                                    }, _toDisplayString(_ctx.$t('LoginPage.logout')), 3)
                                  ]),
                                  _: 1
                                }))
                              : _createCommentVNode("", true)
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ], 32)
            ])
          ])
        ]),
        _: 1
      }),
      false
        ? (_openBlock(), _createBlock(_component_dev_box, { key: 1 }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.store.state), 1)
            ]),
            _: 1
          }))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["class"]))
}